module.exports = __webpack_public_path__ + "img/luca-awards-2022--friendliest-software-of-the-year.91840950.webp";